export default __webpack_public_path__ + "static/media/dog-bed.6406ce3c.jpg";